import { Font } from "@react-pdf/renderer";
import LavishlyYours from "../../assets/fonts/LavishlyYours-Regular.ttf";
import LibreCaslonText from "../../assets/fonts/LibreCaslonText-Regular.ttf";
import VarelaRound from "../../assets/fonts/VarelaRound-Regular.ttf";
import GreatVibes from "../../assets/fonts/GreatVibes-Regular.ttf";

Font.register({ family: "Lavishly Yours", src: LavishlyYours });
Font.register({ family: "Libre Caslon Text", src: LibreCaslonText });
Font.register({ family: "Varela Round", src: VarelaRound });
Font.register({
	family: "Great Vibes",
	fonts: [{ src: GreatVibes }]
});
